import React from 'react'
import { connect } from 'react-redux'
import {Route, Switch} from 'react-router'
// import AnimatedRouterSwitch from '../../../core/components/animated-router-switch/AnimatedRouterSwitch'
import { toJS } from '../../../util/ToJS'
import {
  getProfileProblems,
  getProfileContributions,
  getUserInfo,
  resetProfileData
} from '../../../redux/modules/profile'
import VisibleProblemFeed from './VisibleProblemFeed'
import VisibleContributionsFeed from './VisibleContributionsFeed'
// import VisibleEditProfile from '../edit-profile/containers/VisibleEditProfile'
import Profile from '../components/Profile'

class VisibleProfileComponent extends React.PureComponent {
  componentDidMount() {
    const {
      getProfileProblems,
      getProfileContributions,
      getUserInfo,
      resetProfileData,
      currUserId,
      match
    } = this.props
    document.title = 'Profile ' + match.params.userId + ' - Expii'
    if (parseInt(currUserId) !== parseInt(match.params.userId)) {
      resetProfileData()
      getUserInfo(match.params.userId)
      getProfileProblems(match.params.userId)
      getProfileContributions(match.params.userId)
    }
  }
  componentWillReceiveProps(nextProps) {
    const {
      match,
      getProfileProblems,
      getProfileContributions,
      getUserInfo,
      resetProfileData,
    } = this.props
    const userId = match.params.userId
    const newUserId = nextProps.match.params.userId

    if (userId !== newUserId) {
      resetProfileData()
      getUserInfo(newUserId)
      getProfileProblems(newUserId)
      getProfileContributions(newUserId)
    }
  }
  render() {
    const {
      match,
      getProfileProblems,
      getProfileContributions
    } = this.props
    const showMoreProblems = () => {
      getProfileProblems(match.params.userId)
    }
    const showMoreContributions = () => {
      getProfileContributions(match.params.userId)
    }
    return (
      <Profile>
        <Switch>
          <Route exact path="/user/:userId/problems"
            component={(props)=>(
              <VisibleProblemFeed
                showPrivacy
                showMore={showMoreProblems}
                {...props}
              />
            )} />
          <Route exact path="/user/:userId"
            component={(props)=>(
              <VisibleContributionsFeed
                showPrivacy
                showMore={showMoreContributions}
                {...props}
              />
            )}
          />
        </Switch>
      </Profile>
    )
  }
}

const mapStateToProps = state => {
  return {
    currUserId: state.getIn(['profile', 'userInfo', 'id'])
  }
}
const mapDispatchToProps = dispatch => ({
  getProfileProblems: userId => dispatch(getProfileProblems(userId)),
  getProfileContributions: userId => dispatch(getProfileContributions(userId)),
  getUserInfo: userId => dispatch(getUserInfo(userId)),
  resetProfileData: () => dispatch(resetProfileData())
})
const VisibleProfile = connect(mapStateToProps, mapDispatchToProps)(
  toJS(VisibleProfileComponent)
)

export default VisibleProfile



// WEBPACK FOOTER //
// ./src/domains/user/containers/VisibleProfile.js